import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M19 6.664c.552 0 1-.458 1-1.023 0-1.257.783-1.832 2.698-2.03q.636-.066 1.302-.066t1.302.066C27.217 3.81 28 4.384 28 5.641c0 .565.448 1.023 1 1.023s1-.458 1-1.023c0-2.537-1.684-3.774-4.497-4.065Q24.767 1.501 24 1.5q-.766 0-1.503.076C19.685 1.866 18 3.104 18 5.641c0 .565.448 1.023 1 1.023m1 30.511c0 .565-.448 1.023-1 1.023s-1-.458-1-1.023V18.886c0-.564.448-1.022 1-1.022s1 .457 1 1.022zm9 1.023c.552 0 1-.458 1-1.023V18.886c0-.564-.448-1.022-1-1.022s-1 .457-1 1.022v18.29c0 .564.448 1.022 1 1.022"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M40 23.967V15.81c.397-.02.673-.094.96-.25a1.93 1.93 0 0 0 .788-.806c.187-.358.252-.7.252-1.27V11.72c-.005-2.257-1.797-4.082-4.002-4.077l-13.76.03h-.116l-14.127-.03C7.788 7.643 6 9.47 6 11.727v1.757c0 .57.065.913.252 1.27.18.346.45.622.788.807.287.156.563.23.96.25v8.255q0 8.276.54 15.427c.262 3.479 2.939 6.258 6.336 6.578a97 97 0 0 0 18.247-.003c3.398-.32 6.076-3.1 6.338-6.58Q40 32.325 40 23.968m-30 .1v-8.249h28v8.149q0 8.282-.533 15.365c-.188 2.485-2.1 4.47-4.527 4.699a95 95 0 0 1-17.88.003c-2.427-.229-4.339-2.213-4.526-4.698Q10 32.265 10 24.066m30-10.583v-1.756c-.002-1.131-.897-2.042-1.998-2.04l-13.76.03h-.124l-14.12-.03C8.893 9.687 8 10.6 8 11.727v1.756c0 .185.002.251.007.281.03.005.094.008.275.008h31.436c.181 0 .245-.002.275-.008.005-.03.007-.096.007-.28",
      clipRule: "evenodd"
    }
  )
);
var SvgTrashOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var TrashOutlined_default = SvgTrashOutlined;

export { TrashOutlined_default as default };
